import { createAction } from 'redux-actions';

export const SHOW_SETTINGS = 'SHOW_SETTINGS';
export const HIDE_SETTINGS = 'HIDE_SETTINGS';
export const SET_PAYMENT_SESSION_ID = 'SET_PAYMENT_SESSION_ID';
export const SET_USERDATA = 'SET_USERDATA';
export const SET_SOUND_ENABLE = 'SET_SOUND_ENABLE';
export const REDIRECT_TO_PAYMNET = 'REDIRECT_TO_PAYMNET';

export const showSettings = createAction(SHOW_SETTINGS);
export const hideSettings = createAction(HIDE_SETTINGS);
export const setPaymentSessionId = createAction(SET_PAYMENT_SESSION_ID);
export const setUserdata = createAction(SET_USERDATA);
export const setSoundEnable = createAction(SET_SOUND_ENABLE);
export const redirectToPayment = createAction(REDIRECT_TO_PAYMNET);